'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dEmail$0024 from "./presto.types$-Email$.js";
var $p;
/** @constructor */
function $c_Lpresto_OystrAdminView$$anon$1(outer) {
  this.b7Q = null;
  this.b7O = null;
  this.b7P = false;
  this.b7M = null;
  this.b7N = false;
  this.b7R = false;
  this.b7S = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.b7Q = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_OystrAdminView$$anon$1 as $c_Lpresto_OystrAdminView$$anon$1 };
$p = $c_Lpresto_OystrAdminView$$anon$1.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_OystrAdminView$$anon$1;
/** @constructor */
function $h_Lpresto_OystrAdminView$$anon$1() {
}
export { $h_Lpresto_OystrAdminView$$anon$1 as $h_Lpresto_OystrAdminView$$anon$1 };
$h_Lpresto_OystrAdminView$$anon$1.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.b7Q;
});
$p.t = (function() {
  if ((!this.b7P)) {
    this.b7O = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("email", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("magic", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.b7P = true;
  }
  return this.b7O;
});
$p.ae = (function() {
  if ((!this.b7N)) {
    this.b7M = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dEmail$0024.$m_Lpresto_types$Email$().p8(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.b7N = true;
  }
  return this.b7M;
});
$p.w = (function() {
  if ((!this.b7S)) {
    this.b7R = false;
    this.b7S = true;
  }
  return this.b7R;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_OystrAdminView$$anon$1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_OystrAdminView$$anon$1, "presto.OystrAdminView$$anon$1", ({
  MA: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_OystrAdminView$$anon$1 as $d_Lpresto_OystrAdminView$$anon$1 };
//# sourceMappingURL=presto.-Oystr-Admin-View$$anon$1.js.map
